import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first, debounceTime, throwIfEmpty } from 'rxjs/operators';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { AlertService } from '../../../shared/components/alert/alert.service';
import { UserService } from '../../shared/services/user.service';
import { LookupService } from '../../shared/services/lookup.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { Observable, Subscription, of } from 'rxjs';
import { RegistrationType } from '../../shared/models/register-type.model';
import { Country } from '../../shared/models/country.model';
import { PortalUserType } from '../../shared/models/portal-user-type.model';
import { MustMatch } from '../../shared/validator/must-match.validator';
import { User } from 'src/app/front-user/shared/models/user.model';
import { RegisterType, Languages, Service, ServiceStatus, FormMode, CertificateTypes } from 'src/app/shared/models/enums.model';
import { ReCaptcha2Component } from 'ngx-captcha';
import { AppConfig } from 'src/app/shared/services/app.config';
import { PasswordStrengthValidator } from '../../shared/validator/password-strength.validators';
import { AgentRepresentative } from '../../services/e-booking/shared/models/agent-representative.model';
import { AgentRegistrationComponent } from '../../services/e-booking/agent-registration/agent-registration.component';
import { AgentInfo } from '../../services/e-booking/shared/models/agent.model';
import { MembershipService } from '../../services/e-booking/shared/services/membership.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseRequestService } from '../../shipyard-service/services/base-request.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { AgentService } from '../../services/e-booking/shared/services/agent.service';
import { SupplierDTO, SupplierPartnershipCategoryDTO } from 'src/app/shared/models/e-tender.model';
import { CustomValidators } from '../../shipyard-service/models/custom-validator';
import { SupplierRegistrationComponent } from '../../services/e-tender/supplier-registration/supplier-registration.component';
import { SupplierService } from 'src/app/shared/services/supplier.service';
//import { SearchCountryField, TooltipLabel } from 'ngx-intl-tel-input';
declare var isRegistration;
declare var regRequestId;



@Component({
    templateUrl: 'register.component.html',
    selector: 'register',
})
export class RegisterComponent implements OnInit, AfterViewInit {
    IsSupplierRegistrationAvailable: boolean = false;
    registrationAvailability: number[] = [];
    ServiceStatus = ServiceStatus;
    registerForm: FormGroup;
    showTeasuryNumber: boolean = false;
    loading = false;
    submitted = false;
    responseObject: ResponseObject = new ResponseObject;
    private _subs: Subscription;
    registrationTypes: RegistrationType[];
    Countries: Country[];
    portalUserTypes: PortalUserType[];
    preferredServices = [{ Id: 1, NameEN: 'Long Haul Rebates', NameAR: 'تخفيضات الخطوط الطويلة' },
    { Id: 2, NameEN: 'Shipyard Services', NameAR: 'خدمات الترسانات' }];
    user: User = new User();
    loggedInUser: User = new User();
    public RegisterType: any = RegisterType;
    sitekey = AppConfig.settings.apiServer.captchaSiteKey;
    public captchaIsLoaded = false;
    public captchaSuccess = false;
    public captchaIsExpired = false;
    public captchaResponse?: string;
    public agentInfo: AgentInfo = new AgentInfo();
    public CertificateTypes: any = CertificateTypes;
    public updatedAgentInfo: AgentInfo = new AgentInfo();
    public getAgentInfo: AgentInfo = new AgentInfo();
    agentId: string;
    isReadOnly: boolean;
    displayedLang: any;
    representativeName: string;
    private agentRep: AgentRepresentative[] = [];
    @ViewChild('captchaElem',{static: false}) captchaElem: ReCaptcha2Component;
    @ViewChild('register',{static: false}) namefield: ElementRef;
    @ViewChild('agentChild',{static: false}) agentChild: AgentRegistrationComponent;
    @ViewChild('supplierChild',{static: false}) supplierChild: SupplierRegistrationComponent;
    emailRegex: string = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\\.)[a-zA-Z0-9-.]+$';
    numberRegex: string = '^[0-9]*$';
    public Languages: any = Languages;
    registrationType: number;
    // SearchCountryField = SearchCountryField;
    //TooltipLabel = TooltipLabel;
    requestStatus: number;
    baseRequestDTO: BaseRequest;
    @Input() public isOffline: boolean = false;
    @Input() IsAdminMode: boolean = false;
    lang: string = 'en';
    //  @Output() formReady = new EventEmitter<FormGroup>()
    public FormMode: any = FormMode;
    public formMode = FormMode.Add;
    showRequest = false;
    userName: string;
    userNameError: any = { isError: false, errorMessage: '' };
    //#region  Supplier Registration Propersties
    public supplierInfo: SupplierDTO = new SupplierDTO();
    supplierId: string;
    public updatedSupplierInfo: SupplierDTO = new SupplierDTO();
    supplierPartnershipsCategories: SupplierPartnershipCategoryDTO[][] = new Array();
    supplierPartnershipCategories: SupplierPartnershipCategoryDTO[] = new Array<SupplierPartnershipCategoryDTO>();
    @ViewChild('divSupplierChild',{static: false}) supplierChildElementRef: ElementRef;
    isLocalSupplier: boolean = false;
    isSupplierRegistrationType: boolean = false;
    isSupplierFormValid: boolean = undefined;
    //#endregion


    isTabOneValid: boolean = false;
    isTabTwoValid: boolean = false;
    // isShowSubmit: boolean = false;
    requestId: string;
    isCompleted: boolean = false;
    showAgentMsg: boolean = false;
    showSupplierMsg: boolean = false;
    agentEmail: string;

    showSubmit: boolean = false;

    public fixedTimeGMT: string = ",12:00:00 PM";

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private userService: UserService,
        private lookupService: LookupService,
        private route: ActivatedRoute,
        private membershipService: MembershipService,
        private globalSrv: GlobalServices,
        private translate: TranslateService,
        private baseRequestService: BaseRequestService,
        private agentSrv: AgentService,
        private supplierService: SupplierService,
        private activatedRoute: ActivatedRoute

    ) {
        this.displayedLang = this.globalSrv.getLanguage();
        if (this.displayedLang == Languages.Arabic) {
            this.lang = 'ar';
        }
        else {
            this.lang = 'en';
        }
        this.loggedInUser = this.authenticationService.currentUserValue;
        if (history.state.data && history.state.data.requestId) {
            this.agentId = history.state.data.requestId;
        }
        else if (this.activatedRoute.snapshot.queryParams.UserID) {
            this.agentId = this.activatedRoute.snapshot.queryParams.UserID;
        }



        if (this.agentId) {
            isRegistration = true;
            this.baseRequestService.getByRequestorId(this.agentId, Service.AgentRegisteration).subscribe(
                d => {
                    this.baseRequestDTO = d.Data;
                    regRequestId = this.baseRequestDTO.Id;
                    this.requestId = this.baseRequestDTO.Id;
                    this.requestStatus = this.baseRequestDTO.StatusId;
                    if (this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent && this.loggedInUser.UserId == this.agentId) {
                        this.showSubmit = true;
                        this.formMode = FormMode.Edit;
                        this.registerForm.controls.username.disable();
                        this.registerForm.controls.password.disable();
                        this.registerForm.controls.confirmpassword.disable();
                        this.registerForm.controls.registrationType.disable();
                        this.isReadOnly = false;
                    }
                    else {
                        this.formMode = FormMode.Readonly;
                        this.isReadOnly = true;
                        this.registerForm.disable();
                    }
                    this.isTabOneValid = true;
                    this.isTabTwoValid = true;
                }
            );

            this.agentSrv.GetAgentOnly(this.agentId).subscribe(d => {
                this.getAgentInfo = d.Data;
                if (history.state.data && history.state.data.isCompleted) {
                    this.formMode = FormMode.Readonly;
                    this.isReadOnly = true;
                    this.registerForm.disable()
                    if (this.getAgentInfo.MoreInformation) {
                        this.isCompleted = true;
                    }
                }
                if (this.getAgentInfo.MoreInformation && this.loggedInUser.IsAdmin && this.requestStatus == ServiceStatus.PendingonRegistrationAdminApproval) {
                    this.isCompleted = true;
                }
            });
            this.editUser();
        } else if (this.supplierId) {
            // Supplier Registration : TODO
            // this.baseRequestService.getByRequestorId(this.supplierId, Service.SupplierRegistration).subscribe(
            //     d => {
            //         this.baseRequestDTO = d.Data;
            //         this.requestStatus = this.baseRequestDTO.StatusId;
            //         if (this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent) {

            //             this.formMode = FormMode.Edit;
            //             this.registerForm.controls.username.disable();
            //             this.registerForm.controls.password.disable();
            //             this.registerForm.controls.confirmpassword.disable();
            //             this.registerForm.controls.registrationType.disable();
            //             this.isReadOnly = false;
            //         }
            //         else {
            //             this.formMode = FormMode.Readonly;
            //             this.isReadOnly = true;
            //             this.registerForm.disable();
            //         }
            //     }
            // );

            // this.agentSrv.GetAgentOnly(this.agentId).subscribe(d => {
            //     this.getAgentInfo = d.Data;
            // });
            // this.editUser();
        }

    }

    ngOnInit() {
        this.globalSrv.isLoaderEnabled = true;
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue && !this.agentId && !this.isOffline) {
            this.globalSrv.goToHome();
        }
        //this.isReadOnly = this.agentId ? true : false;
        //this.agentId ? this.registerForm.disable() : null;
        this.buildForm();

        this.lookupService.getCountries()
            .subscribe((data: ResponseObject) => {
                this.Countries = data.Data as Country[];
            }
            );
        this.lookupService.getRegistrationType()
            .subscribe((data: ResponseObject) => {
                this.registrationTypes = data.Data as RegistrationType[];
                //remove agent from ddl
                //this.registrationTypes = this.registrationTypes.filter(item => item.Id != RegisterType.Agent);
                if (this.isOffline) {
                    //this.formReady.emit(this.registerForm);
                    this.registerForm.patchValue({
                        registrationType: RegisterType.Agent
                    });
                    this.registrationTypes = this.registrationTypes.filter(item => item.Id == RegisterType.Agent);

                    this.user.RegisterTypeId = RegisterType.Agent;
                }
            });

        this.lookupService.getPortalUserType()
            .subscribe((data: ResponseObject) => {
                this.portalUserTypes = data.Data as PortalUserType[];

            });  
    }

    receiveAgent($event) {
        this.agentInfo = $event
    }
    receiveUpdatedAgent($event) {
        this.updatedAgentInfo = $event
    }
    //Supplier emitters Registraton
    receiveIsLocalSupplier($event) {
        this.isLocalSupplier = $event;
    }
    receiveSupplier($event) {
        this.supplierInfo = $event
    }
    receiveUpdatedSupplier($event) {
        this.updatedSupplierInfo = $event
    }
    receiveIsSupplierFormValid($event) {
        this.isSupplierFormValid = $event
    }


    receiveTabOne($event) {
        this.isTabOneValid = $event
    }
    receiveTabTwo($event) {
        this.isTabTwoValid = $event;

    }
    // receiveShowSubmit($event) {
    //     this.isShowSubmit = $event;
    // }
    receiveRepresentative($event) {
        this.representativeName = $event;
        let userNameControl = this.registerForm.get('username').value;
        if (userNameControl.toLowerCase() == this.representativeName.toLowerCase()) {
            this.userNameError = { isError: true, errorMessage: this.translate.instant('FRONT_USER.ERRORS_MESSAGES.DuplicateUserNameAgent') };
            this.registerForm.get('username').setErrors({ 'invalid': true });
        } else {
            this.userNameError = { isError: false, errorMessage: '' };
            this.registerForm.get('username').setValidators([Validators.required, Validators.pattern(this.emailRegex), CustomValidators.textSpaceValidator()]);
            this.registerForm.get('username').updateValueAndValidity();
        }
    }
    ngAfterViewInit(): void {

        this.globalSrv.isLoaderEnabled = false;
    }

    buildForm() {
        this.registerForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.pattern(this.emailRegex), CustomValidators.textSpaceValidator()]],
            password: ['', [Validators.required, PasswordStrengthValidator]],
            confirmpassword: ['', Validators.required],
            registrationType: [null, Validators.required],
            userType: [null, Validators.required],
            PreferedServiceId: [null, Validators.required],
            fullName: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
            country: [null, Validators.required],
            address: [''],
            mobile: ['', [Validators.required]],
            fax: ['', Validators.pattern(this.numberRegex)],
            organization: [''],
            agent: new FormControl(""),
            supplier: new FormControl(""),
            recaptcha: ['', Validators.required],
            TermsAndConditions: [false, [Validators.requiredTrue]],
        },
            { validator: MustMatch('password', 'confirmpassword') });

        // if (this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent) {
        //     this.registerForm.addControl('MoreInformation', new FormControl({ disabled: true }));
        // }
    }
    // convenience getter for easy access to form fields
    get f() {
        return this.registerForm.controls;
    }

    onSubmit() {
        if (this.user.RegisterTypeId != RegisterType.PortalUser) {
            this.registerForm.get('userType').clearValidators();
            this.registerForm.get('userType').updateValueAndValidity();
            this.registerForm.get('PreferedServiceId').clearValidators();
            this.registerForm.get('PreferedServiceId').updateValueAndValidity();
            this.registerForm.get('fullName').clearValidators();
            this.registerForm.get('fullName').updateValueAndValidity();
            this.registerForm.get('country').clearValidators();
            this.registerForm.get('country').updateValueAndValidity();
            this.registerForm.get('mobile').clearValidators();
            this.registerForm.get('mobile').updateValueAndValidity();
        }
        // if (this.user.RegisterTypeId == RegisterType.PortalUser) {
        //     if (this.registerForm.controls.country.value == 'null' ||
        //         this.registerForm.controls.userType.value == 'null' ||
        //         this.registerForm.controls.registrationType.value == 'null'
        //     ) {
        //         this.registerForm.setErrors({ invalid: true });
        //     }
        // }
        //**remove capytcha for automation testing**//////
        if (this.formMode != FormMode.Add) {
            this.registerForm.get('recaptcha').clearValidators();
            this.registerForm.get('recaptcha').updateValueAndValidity();
            this.registerForm.get('TermsAndConditions').clearValidators();
            this.registerForm.get('TermsAndConditions').updateValueAndValidity();
        }
        //******************* */
        // nashwa validation focus


        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid || this.registerForm.controls.country.value == 'null' ||
            this.registerForm.controls.userType.value == 'null' ||
            this.registerForm.controls.registrationType.value == 'null') {
            // TODO
            // this.supplierChild.allSelectedSupplierPartnershipCategoriesIds = new Array();
            const invalidElements = this.namefield.nativeElement.querySelectorAll('.ng-invalid');
            if (invalidElements.length > 0) {
                if (this.user.RegisterTypeId == RegisterType.Agent) {
                    if (!this.isTabOneValid) {
                        invalidElements[0].focus();
                        this.navigateToTab(0);
                    }
                    else if (!this.isTabTwoValid) {
                        invalidElements[0].focus();
                        this.navigateToTab(1);
                    }
                    else {
                        invalidElements[0].focus();
                        this.navigateToTab(2)
                    }
                }
                else {
                    invalidElements[0].focus();
                }
            }
            return;
        }
        const invalidElements = this.namefield.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidElements.length > 0) {
            if (this.user.RegisterTypeId == RegisterType.Agent) {
                if (!this.isTabOneValid) {
                    invalidElements[0].focus();
                    this.navigateToTab(0);
                }
                else if (!this.isTabTwoValid) {
                    invalidElements[0].focus();
                    this.navigateToTab(1);
                }
                else {
                    invalidElements[0].focus();
                    this.navigateToTab(2)
                }
            }
            else {
                invalidElements[0].focus();
            }
            return;
        }
        this.loading = true;

        this.alertService.clear();
        this.globalSrv.isLoaderEnabled = true;
        this.user.UserName = this.registerForm.controls.username.value;
        this.user.Password = this.globalSrv.encryptPassword(this.registerForm.controls.password.value);
        this.user.ConfrimPassword = this.globalSrv.encryptPassword(this.registerForm.controls.confirmpassword.value);
        this.user.RegisterTypeId = this.registerForm.controls.registrationType.value;
        if (this.user.RegisterTypeId == RegisterType.PortalUser) {
            this.user.PortalUser.RegisterTypeId = this.registerForm.controls.registrationType.value;
            this.user.PortalUser.PortalUserTypeId = this.registerForm.controls.userType.value;
            this.user.PortalUser.PreferedServiceId = this.registerForm.controls.PreferedServiceId.value;
            this.user.PortalUser.FullName = this.registerForm.controls.fullName.value;
            this.user.PortalUser.CountryId = this.registerForm.controls.country.value;
            this.user.PortalUser.Mobile = this.registerForm.controls.mobile.value;
            this.user.PortalUser.Fax = this.registerForm.controls.fax.value;
            this.user.PortalUser.Organization = this.registerForm.controls.organization.value;
        }
        if (this.user.RegisterTypeId == RegisterType.Agent) {
            this.user.Agent.RegisterTypeId = this.registerForm.controls.registrationType.value;
            this.user.Agent.Name = this.registerForm.controls.agent.value.name;;
            this.user.Agent.DisplayName = this.registerForm.controls.agent.value.displayName;
            this.user.Agent.Address = this.registerForm.controls.agent.value.address;
            this.user.Agent.Phone1 = this.registerForm.controls.agent.value.phone1;
            this.user.Agent.Phone2 = this.registerForm.controls.agent.value.phone2;
            this.user.Agent.Fax = this.registerForm.controls.agent.value.fax;
            this.user.Agent.ContactPerson = this.registerForm.controls.agent.value.contactPerson;

            this.user.Agent.AgentCurrencies = this.registerForm.controls.agent.value.agentCurrency.currencyId.map(function (obj) {
                return {
                    CurrencyId: obj.Id,
                    Id: obj.AgentCurrencyId
                }
            });
            this.agentRep = this.registerForm.controls.agent.value.agentRepresentative.map(function (obj) {
                return {
                    UserName: obj.username,
                    Password: obj.password,
                    NationalId: obj.nationalId,
                    UserId: obj.UserId
                }
            });
            this.user.Agent.AgentRepresentatives = this.agentRep;
            if (this.formMode == FormMode.Edit) {

                this.user.Agent.AgentCertificates = this.updatedAgentInfo.AgentCertificates;
            }
            if (this.formMode == FormMode.Add) {

                this.user.Agent.AgentCertificates = this.agentChild.agentCertificate;
            }

            let dateNow = new Date();
            this.user.Agent.AgentCertificates.forEach((key: any, vals: any) => {
                if (key.CertificateType == CertificateTypes.shippingLicensing && this.registerForm.controls.agent.value.agentCertificate.shippingExpirationDate) {
                    var selectedshippingtDate = this.registerForm.controls.agent.value.agentCertificate.shippingExpirationDate.toLocaleString('en-US');
                    key.ExpirationDate = selectedshippingtDate;

                }
                if (key.CertificateType == CertificateTypes.Taxcard && this.registerForm.controls.agent.value.agentCertificate.taxCardExpirationDate) {
                    // key.ExpirationDate = this.registerForm.controls.agent.value.agentCertificate.taxCardExpirationDate;
                    var selectedTaxcardtDate = this.registerForm.controls.agent.value.agentCertificate.taxCardExpirationDate.toLocaleString('en-US');
                    key.ExpirationDate = selectedTaxcardtDate;

                }
                if (key.CertificateType == CertificateTypes.Taxcardappendix && this.registerForm.controls.agent.value.agentCertificate.taxCardAppendixExpirationDate) {
                    var selectedTaxcardtAppendixDate = this.registerForm.controls.agent.value.agentCertificate.taxCardAppendixExpirationDate.toLocaleString('en-US');
                    key.ExpirationDate = selectedTaxcardtAppendixDate;

                }
                if (key.CertificateType == CertificateTypes.TaxAuthorization && this.registerForm.controls.agent.value.agentCertificate.taxAuthorizationExpirationDate) {
                    var selectedTaxAuthDate = this.registerForm.controls.agent.value.agentCertificate.taxAuthorizationExpirationDate.toLocaleString('en-US');
                    key.ExpirationDate = selectedTaxAuthDate;

                }
                if (key.CertificateType == CertificateTypes.CommercialRecord && this.registerForm.controls.agent.value.agentCertificate.commercialRecordExpirationDate) {
                    var selectedCommercialRecordDate = this.registerForm.controls.agent.value.agentCertificate.commercialRecordExpirationDate.toLocaleString('en-US');
                    key.ExpirationDate = selectedCommercialRecordDate;
                }
                if (key.CertificateType == CertificateTypes.OtherDocuments && this.registerForm.controls.agent.value.agentCertificate.otherDocumentsExpirationDate) {
                    var selectedOtherDocumentsDate = this.registerForm.controls.agent.value.agentCertificate.otherDocumentsExpirationDate.toLocaleString('en-US');
                    key.ExpirationDate = selectedOtherDocumentsDate;
                }
            });

            this.user.Agent.AgentCertificates = this.user.Agent.AgentCertificates.filter(item => item.URL != '' && item.ExpirationDate);
        }
        //TO DO: Supplier Registration
        if (this.user.RegisterTypeId == RegisterType.Supplier) {
            //Bassic.Info
            this.user.Supplier.UserId = null;
            this.user.Supplier.IsLocalSupplier = this.registerForm.controls.supplier.value.IsLocalSupplier;
            this.user.Supplier.SupplierNatureId = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.SupplierNatureId;
            this.user.Supplier.SupplierTypeId = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.SupplierTypeId;
            this.user.Supplier.CompanyName = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.CompanyName;
            this.user.Supplier.CommercialName = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.CommercialName;
            // Date Issue
            // this.user.Supplier.CommercialRecordExpiryDate = new Date(this.registerForm.controls.supplier.value.BasicSupplierInfoTab.CommercialRecordExpiryDate);
            if (this.registerForm.controls.supplier.value.BasicSupplierInfoTab.CommercialRecordExpiryDate) {
                var selectedCommercialRecordExpiryDate = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.CommercialRecordExpiryDate.toLocaleDateString('en-US');
                this.user.Supplier.CommercialRecordExpiryDate = new Date(Date.parse(selectedCommercialRecordExpiryDate + this.fixedTimeGMT));
            }

            // this.user.Supplier.TaxCardExpiryDate = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.TaxCardExpiryDate;
            if (this.registerForm.controls.supplier.value.BasicSupplierInfoTab.TaxCardExpiryDate) {
                var selectedTaxCardExpiryDate = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.TaxCardExpiryDate.toLocaleDateString('en-US');
                this.user.Supplier.TaxCardExpiryDate = new Date(Date.parse(selectedTaxCardExpiryDate + this.fixedTimeGMT));
            }

            // this.user.Supplier.VATRegistrationDate = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.VATRegistrationDate;
            if (this.registerForm.controls.supplier.value.BasicSupplierInfoTab.VATRegistrationDate) {
                var selectedVATRegistrationDate = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.VATRegistrationDate.toLocaleDateString('en-US');
                this.user.Supplier.VATRegistrationDate = new Date(Date.parse(selectedVATRegistrationDate + this.fixedTimeGMT));
            }

            // this.user.Supplier.ActivityLegalRecordRegistrationDate = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.ActivityLegalRecordRegistrationDate;
            if (this.registerForm.controls.supplier.value.BasicSupplierInfoTab.ActivityLegalRecordRegistrationDate) {
                var selectedActivityLegalRecordRegistrationDate = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.ActivityLegalRecordRegistrationDate.toLocaleDateString('en-US');
                this.user.Supplier.ActivityLegalRecordRegistrationDate = new Date(Date.parse(selectedActivityLegalRecordRegistrationDate + this.fixedTimeGMT));
            }

            // this.user.Supplier.CompanyEstablishingDate = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.CompanyEstablishingDate;
            if (this.registerForm.controls.supplier.value.BasicSupplierInfoTab.CompanyEstablishingDate) {
                var selectedCompanyEstablishingDate = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.CompanyEstablishingDate.toLocaleDateString('en-US');
                this.user.Supplier.CompanyEstablishingDate = new Date(Date.parse(selectedCompanyEstablishingDate + this.fixedTimeGMT));
            }

            this.user.Supplier.CommercialRecordNumber = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.CommercialRecordNumber;
            this.user.Supplier.IndustrialRegistrationNumber = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.IndustrialRegistrationNumber;
            this.user.Supplier.TaxRecordNumber = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.TaxRecordNumber;
            // this.user.Supplier.TaxCardNumber = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.TaxCardNumber;
            this.user.Supplier.TaxAuthority = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.TaxAuthority;
            this.user.Supplier.VATNumber = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.VATNumber;
            this.user.Supplier.ActivityLegalRecordRegistrationNumber = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.ActivityLegalRecordRegistrationNumber;
            this.user.Supplier.PaidCapital = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.PaidCapital;
            this.user.Supplier.AverageAnnualTurnover = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.AverageAnnualTurnover;
            this.user.Supplier.AverageAnnualTurnoverCurrencyId = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.AverageAnnualTurnoverCurrencyId;

            //Contractor Info
            this.user.Supplier.ConstructionNumber = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.ConstructionNumber;
            this.user.Supplier.ContractorCategoryId = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.ContractorCategoryId;
            this.user.Supplier.ContractorClassificationId = this.registerForm.controls.supplier.value.BasicSupplierInfoTab.ContractorClassificationId;

            //ContactInfo
            this.user.Supplier.Address = this.registerForm.controls.supplier.value.ContactInfoTab.Address;
            this.user.Supplier.PostalCode = this.registerForm.controls.supplier.value.ContactInfoTab.PostalCode;
            this.user.Supplier.ContactPersonName = this.registerForm.controls.supplier.value.ContactInfoTab.ContactPersonName;
            this.user.Supplier.Phone = this.registerForm.controls.supplier.value.ContactInfoTab.Phone;
            this.user.Supplier.Fax = this.registerForm.controls.supplier.value.ContactInfoTab.Fax;
            this.user.Supplier.ContactPersonEmail = this.registerForm.controls.supplier.value.ContactInfoTab.ContactPersonEmail;
            this.user.Supplier.GovernorateId = this.registerForm.controls.supplier.value.ContactInfoTab.GovernorateId;
            this.user.Supplier.WebSiteURL = this.registerForm.controls.supplier.value.ContactInfoTab.WebSiteURL;

            //Maintenance Info
            this.user.Supplier.MaintenanceCenterAddress = this.registerForm.controls.supplier.value.SupplierMaintenanceTab.MaintenanceContactPerson;
            this.user.Supplier.MaintenanceContactPerson = this.registerForm.controls.supplier.value.SupplierMaintenanceTab.MaintenanceContactPerson;
            this.user.Supplier.MaintenancePhone = this.registerForm.controls.supplier.value.SupplierMaintenanceTab.MaintenancePhone;
            this.user.Supplier.MaintenanceFax = this.registerForm.controls.supplier.value.SupplierMaintenanceTab.MaintenanceFax;
            this.user.Supplier.AccountStatusId = null; // this.registerForm.controls.supplier.value.SupplierMaintenanceTab.AccountStatusId;
            this.user.Supplier.DisableReason = null; //this.registerForm.controls.supplier.value.SupplierMaintenanceTab.DisableReason;

            //Attachments
            this.user.Supplier.SupplierAttachments = this.supplierChild.supplierRegistrationFormAttachments;

            //Supplier Banks
            this.user.Supplier.SupplierBanks = this.registerForm.controls.supplier.value.SupplierBanks.map(function (obj) {
                return {
                    // BankName: obj.BankName,
                    BankId: obj.BankId,
                    BankBranch: obj.BankBranch,
                    AccountNumber: obj.AccountNumber
                }
            });

            //Supplier Specialities
            this.user.Supplier.SupplierSpecialities = this.registerForm.controls.supplier.value.SupplierSpecialities.map(function (obj) {

                return {
                    SpecialityId: obj.SpecialityId,
                    ContactPerson: obj.CategoryContactPerson,
                    Email: obj.CategoryEmail,
                    Fax: obj.CategoryFax,
                    Mobile: obj.CategoryMobile,
                    // Address: obj.CategoryAddress,
                    ExperienceCopyURL: obj.CategoryExperienceCopyURL,
                    ExperienceCopyName: obj.CategoryExperienceCopyName,
                    Speciality: null,
                    Supplier: null,
                    ETenderSuppliers: null
                }
            });
            //Supplier Certificates
            this.user.Supplier.SupplierCertificates = this.registerForm.controls.supplier.value.SupplierCertificates.map(function (obj) {
                return {
                CertificateType: obj.CertificateTypeId,
                CertificateTypeOther: obj.CertificateTypeOther,
                DocumentName: obj.CertificateCopyName,
                URL: obj.CertificateCopyURL
                }
            });
            // Date Issue
            // this.user.Supplier.SupplierPartnerships = this.registerForm.controls.supplier.value.SupplierPartnerships.map(function (obj) {
            //     return {
            //         PartnerName: obj.PartnerName,
            //         NationalityId: obj.NationalityId,
            //         RegisterationDate: obj.RegisterationDate,
            //         PartnerWebsiteURL: obj.PartnerWebsiteURL,
            //         SupplierCommercialAgencyCopyURL: obj.SupplierCommercialAgencyCopyURL,
            //         SupplierCommercialAgencyCopyName: obj.SupplierCommercialAgencyCopyName,
            //         SupplierPartnershipCategories: obj.SelectedSupplierPartnershipCategories.map(function (key) {
            //             return {
            //                 CategoryId: key.Id
            //             }
            //         })
            //     }
            // });

            if (this.registerForm.controls.supplier.value.SupplierPartnerships && this.registerForm.controls.supplier.value.SupplierPartnerships.length > 0) {
                this.user.Supplier.SupplierPartnerships = this.registerForm.controls.supplier.value.SupplierPartnerships.map(function (obj) {
                    return {
                        PartnerName: obj.PartnerName,
                        NationalityId: obj.NationalityId,
                        RegisterationDate: new Date(obj.RegisterationDate.toLocaleDateString('en-US') + ",12:00:00 PM"),
                        PartnerWebsiteURL: obj.PartnerWebsiteURL,
                        SupplierCommercialAgencyCopyURL: obj.SupplierCommercialAgencyCopyURL,
                        SupplierCommercialAgencyCopyName: obj.SupplierCommercialAgencyCopyName,
                        SupplierPartnershipCategories: obj.SelectedSupplierPartnershipCategories.map(function (key) {
                            return {
                                CategoryId: key.Id
                            }
                        })
                    }
                });
            }
        }


        ////////////////////////////////////
        if (this.formMode == FormMode.Add) {
            if (this.isOffline == true) {
                this.user.Agent.IsOffline = true;
            }
            this.userService.register(this.user)
                .pipe(first())
                .subscribe(
                    (data: ResponseObject) => {
                        this.responseObject = data;
                        if (this.responseObject.Success) {
                            //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.ADD_SUCCESSFULLY'), false);
                            this.globalSrv.isLoaderEnabled = false;
                            this.showRequest = true;
                            if (this.user.RegisterTypeId == RegisterType.Agent) {
                                this.showAgentMsg = true;
                                this.agentEmail = this.user.UserName;
                            }
                            else if (this.user.RegisterTypeId == RegisterType.Supplier) {
                                this.showSupplierMsg = true;
                            }
                            else {
                                this.showAgentMsg = false;
                                this.showSupplierMsg = false;
                            }
                            this.registerForm.reset();
                            this.loading = false;
                        }
                        else {
                            this.globalSrv.isLoaderEnabled = false;
                            this.showRequest = false;
                            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + this.responseObject.ErrorMessages[0]), false);
                            // const el = document.getElementsByClassName('alert-danger');
                            // el[0].scrollIntoView({ behavior: 'smooth' });
                            // this.loading = false;
                            window.scrollTo(0, 0);
                        }

                    });
        }
        if (this.formMode == FormMode.Edit) {

            this.user.UserId = this.agentId;

            this.agentSrv.UpdateAgent(this.user)
                .pipe(first())
                .subscribe(
                    (data: ResponseObject) => {
                        this.responseObject = data;
                        if (this.responseObject.Success) {
                            this.globalSrv.isLoaderEnabled = false;
                            this.showRequest = true;
                            //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.ADD_SUCCESSFULLY'), false);
                            this.registerForm.reset();
                            // this.router.navigate(['/Tasks']);
                            this.loading = false;
                        }
                        else {
                            this.globalSrv.isLoaderEnabled = false;
                            this.showRequest = false;
                            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + this.responseObject.ErrorMessages[0]), false);
                            this.loading = false;
                            window.scrollTo(0, 0);
                        }

                    });
        }
    }



    editUser() {
        this.membershipService.GetAspUser(this.agentId).subscribe(
            (resObj: ResponseObject) => {
                this.responseObject = resObj;
                if (this.responseObject.Success) {
                    this.registerForm.patchValue({
                        username: resObj.Data['Email'],
                        password: resObj.Data['Password'],
                        confirmpassword: resObj.Data['Password'],
                        registrationType: resObj.Data['BaseUser'].RegistrationTypeId,
                    });
                    this.user.RegisterTypeId = resObj.Data['BaseUser'].RegistrationTypeId;
                    // if (this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent) {
                    //     this.registerForm.controls['MoreInformation'].setValue(this.agentInfo.MoreInformation);
                    // }
                    // console.log('Success');
                }
                else {
                    // console.log('Fail');
                }
            });
    }


    cancel() {
        this.globalSrv.goToHome();
    }

    clearForm(event) {
        let type = event.target.value;
        this.user.RegisterTypeId = type;
        this.representativeName = '';
        let controls = this.registerForm.get('username');
        this.userNameError = { isError: false, errorMessage: '' };
        controls.setValidators([Validators.required, Validators.pattern(this.emailRegex), CustomValidators.textSpaceValidator()]);
        controls.updateValueAndValidity();
        if (RegisterType.PortalUser.toString() === type) {
            this.isLocalSupplier = false;
            this.isSupplierRegistrationType = false;
            this.registerForm.controls.agent.reset();

            this.registerForm.controls['agent'].setValue('');
            this.registerForm.controls['agent'].setErrors(null);
            this.registerForm.controls.supplier.reset();
            this.registerForm.controls['supplier'].setValue('');
            this.registerForm.controls['supplier'].setErrors(null);
        }
        else if (RegisterType.Agent.toString() === type) {
            this.isLocalSupplier = false;
            this.isSupplierRegistrationType = false;
            this.registerForm.controls.userType.setValue('');
            this.registerForm.controls.PreferedServiceId.setValue('');
            this.registerForm.controls.fullName.setValue('');
            this.registerForm.controls.country.setValue('');
            this.registerForm.controls.mobile.setValue('');
            this.registerForm.controls.fax.setValue('');
            this.registerForm.controls.organization.setValue('');
            this.registerForm.controls.address.setValue('');
            this.registerForm.controls.supplier.reset();
            this.registerForm.controls['supplier'].setValue('');
            this.registerForm.controls['supplier'].setErrors(null);

        }
        else if (RegisterType.Supplier.toString() === type) {
            this.isSupplierRegistrationType = true;
            this.registerForm.controls.userType.setValue('');
            this.registerForm.controls.PreferedServiceId.setValue('');
            this.registerForm.controls.fullName.setValue('');
            this.registerForm.controls.country.setValue('');
            this.registerForm.controls.mobile.setValue('');
            this.registerForm.controls.fax.setValue('');
            this.registerForm.controls.organization.setValue('');
            this.registerForm.controls.address.setValue('');
            this.registerForm.controls.agent.reset();
            this.registerForm.controls['agent'].setValue('');
            this.registerForm.controls['agent'].setErrors(null);
        }


    }
    ClearFormBeforeSubmit(type) {
        if (RegisterType.PortalUser.toString() === type) {
            this.isLocalSupplier = false;
            this.isSupplierRegistrationType = false;
            this.registerForm.controls.agent.reset();

            Object.keys(this.registerForm.controls['agent'].errors).forEach(key => {
                this.registerForm.controls['agent'].errors[key].setErrors(null)
            });
            this.registerForm.controls['agent'].setValue('');
            this.registerForm.controls['agent'].setErrors(null);
            this.registerForm.controls['agent'].updateValueAndValidity();
            this.registerForm.controls.supplier.reset();
            this.registerForm.controls['supplier'].setValue('');
            this.registerForm.controls['supplier'].setErrors(null);
            this.registerForm.controls['supplier'].updateValueAndValidity();
        }
        else if (RegisterType.Agent.toString() === type) {
            this.isLocalSupplier = false;
            this.isSupplierRegistrationType = false;
            this.registerForm.controls.userType.setValue('');
            this.registerForm.controls.PreferedServiceId.setValue('');
            this.registerForm.controls.fullName.setValue('');
            this.registerForm.controls.country.setValue('');
            this.registerForm.controls.mobile.setValue('');
            this.registerForm.controls.fax.setValue('');
            this.registerForm.controls.organization.setValue('');
            this.registerForm.controls.address.setValue('');
            Object.keys(this.registerForm.controls['supplier'].errors).forEach(key => {
                this.registerForm.controls['supplier'].errors[key].setErrors(null);
                this.registerForm.controls['supplier'].updateValueAndValidity();
            });
            this.registerForm.controls.supplier.reset();
            this.registerForm.controls['supplier'].setValue('');
            this.registerForm.controls['supplier'].setErrors(null);
            this.registerForm.controls['supplier'].updateValueAndValidity();

        }
        else if (RegisterType.Supplier.toString() === type) {
            this.isSupplierRegistrationType = true;
            this.registerForm.controls.userType.setValue('');
            this.registerForm.controls.PreferedServiceId.setValue('');
            this.registerForm.controls.fullName.setValue('');
            this.registerForm.controls.country.setValue('');
            this.registerForm.controls.mobile.setValue('');
            this.registerForm.controls.fax.setValue('');
            this.registerForm.controls.organization.setValue('');
            this.registerForm.controls.address.setValue('');
            Object.keys(this.registerForm.controls['agent'].errors).forEach(key => {
                this.registerForm.controls['agent'].errors[key].setErrors(null)
            });
            this.registerForm.controls.agent.reset();
            this.registerForm.controls['agent'].setValue('');
            this.registerForm.controls['agent'].setErrors(null);
            this.registerForm.controls['agent'].updateValueAndValidity();

        }

    }
    goToHome() {
        this.globalSrv.goToHome();
    }

    onChangeUserName(event) {

        let UserName = event.target.value;
        this.userName = UserName;
        let controls = this.registerForm.get('username');
        this.membershipService.DuplicateUserWithSupplier(UserName.toLowerCase()).pipe(debounceTime(1000)).subscribe((data: ResponseObject) => {
            if (!data.Success) {
                this.userNameError = { isError: true, errorMessage: this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]) };
                controls.setErrors({ 'invalid': true });
            }
            else {
                if (UserName == this.representativeName) {
                    this.userNameError = { isError: true, errorMessage: this.translate.instant('FRONT_USER.ERRORS_MESSAGES.DuplicateUserNameAgent') };
                    controls.setErrors({ 'invalid': true });
                } else {
                    this.userNameError = { isError: false, errorMessage: '' };
                    controls.setValidators([Validators.required, Validators.pattern(this.emailRegex), CustomValidators.textSpaceValidator()]);
                    controls.updateValueAndValidity();
                }
            }

        });

    }

    get validateSubmitButton() {
        if (this.isTabOneValid && this.isTabTwoValid) {
            if (this.agentChild.agentTabs.tabs[2].disabled == false &&
                this.agentChild.agentTabs.tabs[2].active == true) {
                this.showSubmit = true;
            }

        }
        return this.showSubmit;
    }

    navigateToTab(tabId: number) {
        this.agentChild.agentTabs.tabs[tabId].disabled = false;
        this.agentChild.agentTabs.tabs[tabId].active = true;
    }

    goToTermsAndCond(): void {
        if (this.displayedLang == Languages.Arabic)
            window.open(AppConfig.settings.apiServer.RegistrationTermsAR, '_blank');
        else
            window.open(AppConfig.settings.apiServer.RegistrationTermsEN, '_blank');
    }
}
